export default __webpack_public_path__ + "static/media/100_pc@2x.23baaa59.png";